import { NgModule } from "@angular/core";
import { ContactFormModalComponent } from "./contact-form/contact-form.component";
import { SuccessModalComponent } from "./success-modal/success-modal.component"; 
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
@NgModule({
    declarations: [ContactFormModalComponent,  SuccessModalComponent],
    imports: [CommonModule, FormsModule,TranslateModule],
    exports: [ContactFormModalComponent, SuccessModalComponent ], 
  })
  export class SupportModule {}